import type {
  SurveyAssignedQuestion,
  BranchingContext,
  BranchRuleInput,
  SurveySummary,
  QuestionAssignmentSummary,
} from '../types';
import { apiFetch } from '../../../../common/api/apiFetchClient';

const SURVEYS_BASE = '/api/rfi/surveys';
const QUESTIONS_BASE = '/api/rfi/questions';

export const assignmentApi = {
  listSurveys(): Promise<{ surveys: SurveySummary[] }> {
    return apiFetch(`${SURVEYS_BASE}`);
  },

  listBySurvey(surveyId: number): Promise<{ questions: SurveyAssignedQuestion[] }> {
    return apiFetch(`${SURVEYS_BASE}/${surveyId}/questions`);
  },

  listByQuestion(questionId: number): Promise<{ assignments: QuestionAssignmentSummary[] }> {
    return apiFetch(`${QUESTIONS_BASE}/${questionId}/assignments`);
  },

  assign(surveyId: number, questionId: number, orderId?: number): Promise<{ assignmentId: number }> {
    return apiFetch(`${SURVEYS_BASE}/${surveyId}/questions`, {
      method: 'POST',
      body: JSON.stringify({ questionId, orderId }),
    });
  },

  deassign(surveyId: number, questionId: number): Promise<unknown> {
    return apiFetch(`${SURVEYS_BASE}/${surveyId}/questions/${questionId}`, {
      method: 'DELETE',
    });
  },

  getBranching(questionId: number, surveyId: number): Promise<BranchingContext> {
    return apiFetch(`${QUESTIONS_BASE}/${questionId}/branching?surveyId=${surveyId}`);
  },

  saveBranching(questionId: number, surveyId: number, rules: BranchRuleInput[]): Promise<unknown> {
    return apiFetch(`${QUESTIONS_BASE}/${questionId}/branching?surveyId=${surveyId}`, {
      method: 'PUT',
      body: JSON.stringify({ rules }),
    });
  },
};
